import { MAX_NODES_PER_ROW, POSITION_GAP } from "../../../../constants/prior";

export class SettingAdapter {
  static toOutputDTO(res: any, req: any | null): any {
    if (!Array.isArray(res)) return [];

    return res.map((edge: any) => {
      const { node_pair_id, source, target, graph_ids } = edge.node_pairs[0];
      const { doc_edge } = edge;

      const isSelected =
        req.graph_id !== null && Array.isArray(graph_ids)
          ? graph_ids.includes(req.graph_id)
          : false;

      return {
        id: edge.client_edge_id,
        edge_id: node_pair_id,
        source: {
          id: source?.value,
          key: source?.name,
          meta: {
            label: doc_edge?.source_term?.value,
            layer: source?.layer_no ?? 1,
          },
        },
        target: {
          id: target?.value,
          key: target?.name,
          meta: {
            label: doc_edge?.target_term?.value,
            layer: target?.layer_no ?? 1,
          },
        },
        status: [
          {
            id: "selected",
            key: "selected",
            value: isSelected,
            meta: { label: "green" },
          },
          {
            id: "unselected",
            key: "unselected",
            value: !isSelected,
            meta: { label: "yellow" },
          },
        ],
      };
    });
  }

  static toInputDTO(req: any): any {
    const { graph_id, title, description, node_pair_ids } = req;
    const dto: any = { title, description, node_pair_ids };
    if (graph_id) {
      dto.graph_id = graph_id;
    }
    return dto;
  }

  static toGraphData(res: any[]): any {
    const nodesMap: Map<string, any> = new Map();
    const edges: any[] = [];

    res?.forEach((node) => {
      const sourceKey = node.source.key;
      const sourceLabel = node.source.meta.label;
      const sourceLayer = node.source.meta.layer;
      if (!nodesMap.has(sourceKey)) {
        nodesMap.set(sourceKey, {
          id: sourceKey,
          data: {
            key: sourceKey,
            meta: { label: sourceLabel, layer: sourceLayer },
          },
          position: { x: 0, y: 0 },
        });
      }

      const targetKey = node.target.key;
      const targetLabel = node.target.meta.label;
      const targetLayer = node.target.meta.layer;
      if (!nodesMap.has(targetKey)) {
        nodesMap.set(targetKey, {
          id: targetKey,
          data: {
            key: targetKey,
            meta: { label: targetLabel, layer: targetLayer },
          },
          position: { x: 0, y: 0 },
        });
      }

      edges.push({
        id: node.edge_id,
        source: sourceKey,
        target: targetKey,
        data: { rule: "white" },
      });
    });

    const nodesByLayer: Map<number, any[]> = new Map();
    nodesMap.forEach((node) => {
      const layer = node.data.meta.layer;
      if (!nodesByLayer.has(layer)) nodesByLayer.set(layer, []);
      nodesByLayer.get(layer)!.push(node);
    });

    const sortedLayers = Array.from(nodesByLayer.keys()).sort((a, b) => a - b);

    let cumulativeRowOffset = 0;
    sortedLayers.forEach((layer) => {
      const nodes = nodesByLayer.get(layer)!;
      nodes.forEach((node, index) => {
        const colIndex = index % MAX_NODES_PER_ROW;
        const rowIndex = Math.floor(index / MAX_NODES_PER_ROW);
        node.position.x = colIndex * POSITION_GAP;
        node.position.y = (cumulativeRowOffset + rowIndex) * POSITION_GAP;
      });

      const rowsUsed = Math.ceil(nodes.length / MAX_NODES_PER_ROW);
      cumulativeRowOffset += rowsUsed;
    });

    return { nodes: Array.from(nodesMap.values()), edges };
  }
}
